//
// Contest actions data component.
//
// This component handles the submission of data for the new Contest Header
//
// eg. Guarantee, Promote etc.
//

import { component as defineComponent } from 'flightjs';

var Actions = function() {
    this.attributes({});

    this.doAction = function(e, data) {
        var xhr = $.ajax({
            type: 'POST',
            url: data.url,
            dataType: 'json',
        });

        xhr.done(
            function(res) {
                this.trigger('dataContestActionSucceeded', res);
            }.bind(this)
        );

        xhr.error(
            function(res) {
                this.trigger('dataContestActionFailed', res);
            }.bind(this)
        );
    };

    this.after('initialize', function() {
        this.on(document, 'uiContestActionRequested', this.doAction);
    });
};

export default defineComponent(Actions);



// WEBPACK FOOTER //
// ./src/web/js/contest/data/actions.js